import { lastValueFrom, map } from 'rxjs';
import { BaseService } from './base-service';
import { formatDateHuman, parseDate } from '../utils/date-utils';
export class DashboardService {
    static getDashboardTiles() {
        return lastValueFrom(BaseService.get(`dashboard-tiles`));
    }
    static getNumSubmissionsByDate() {
        return lastValueFrom(BaseService.get(`dashboard-num-submissions-by-date`).pipe(map(x => {
            x.payload.forEach(y => y.name = formatDateHuman(parseDate(y.name)));
            return x;
        })));
    }
    static getNumSubmissionsByClassroom() {
        return lastValueFrom(BaseService.get(`dashboard-num-submissions-by-classroom`));
    }
    static getNumSuccessfulSubmissionsByClassroom() {
        return lastValueFrom(BaseService.get(`dashboard-num-successful-submissions-by-classroom`));
    }
}
